import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  availableBookedSlotsKey,
  availableSlotsKey,
  errorMessage,
  signupUpdateBlocksRoute,
} from '@features/applicant';
import axiosInstance from '@server/axiosInstance';
import { applicantApplicationsKey } from '@features/applications';
import { eventsKey } from '@features/events';

type useSignupUpdateInterviewProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useSignupUpdateInterview = ({
  setErrorText,
}: useSignupUpdateInterviewProps) => {
  const client = useQueryClient();

  const { mutate: signupUpdateInterview, isLoading: isSignupUpdateInterviewLoading } =
    useMutation({
      mutationFn: (variables: {
        new_block_id: number | null;
        old_block_id: number | null;
        app_id: number;
        slot_id?: number;
        is_slot?: boolean;
      }) =>
        axiosInstance
          .post(signupUpdateBlocksRoute, variables, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          // client.invalidateQueries([availableSlotsKey]);
          client.invalidateQueries([eventsKey]);
          client.invalidateQueries([availableBookedSlotsKey]);
          client.invalidateQueries([applicantApplicationsKey]);
        }
      },
      onError: (error: { message?: string }) => {
        setErrorText(error?.message || errorMessage);
      },
    });

  return {
    signupUpdateInterview,
    isSignupUpdateInterviewLoading,
  };
};
